import React from "react";

const AuthModalFooter: React.FC = () => {
  return (
    <div className="modal-footer-links mt-4 pt-3">
      <div className="footer-links d-flex justify-content-center gap-3 mb-2">
        <a href="/cms/privacy-policy" className="footer-link" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
        <span className="footer-separator">|</span>
        <a href="/cms/terms-and-conditions" className="footer-link" target="_blank" rel="noopener noreferrer">
          Terms of Service
        </a>
        <span className="footer-separator">|</span>
        <a href="/cms/help-center" className="footer-link" target="_blank" rel="noopener noreferrer">
          Help Center
        </a>
      </div>
      <p className="footer-copyright text-muted">© 2025 Rodeo Picks. All rights reserved.</p>
    </div>
  );
};

export default AuthModalFooter;
